import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { MsalService, MsalModule, MsalBroadcastService } from '@azure/msal-angular';
import { AuthenticationResult } from '@azure/msal-browser';
import {
    AlertModule,
    AlertService,
    LayerModule,
    LayerService,
} from '@ed---interne/ng-uui-components';
import { AuthMicrosoftService } from './core/services/auth.microsoft.service';
import { AuthService } from './core/services/auth.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: true,
    imports: [RouterModule, CommonModule, RouterModule, LayerModule, AlertModule, MsalModule],
    providers: [LayerService, AlertService],
})
export class AppComponent implements OnInit {
    title = 'asinterne';

    constructor(
        private msal: MsalService,
        private microsoftAuth: AuthMicrosoftService,
        private auth: AuthService,
        private router: Router,
        private alertService: AlertService,
    ) {}

    ngOnInit(): void {
        // 1) Traiter le redirect MSAL AVANT tout le reste
        this.msal.handleRedirectObservable().subscribe({
            next: async (result: AuthenticationResult | null) => {
                if (result) {
                    // définir le compte actif
                    this.msal.instance.setActiveAccount(result.account);

                    // si tu as une logique d’échange local, déclenche-la ici
                    // void this.authMicrosoft.exchangeForLocalToken({ useAccessToken: true });
                    const localToken = await this.microsoftAuth.exchangeForLocalToken({
                        useAccessToken: false,
                    });
                    if (localToken) {
                        await this.auth.registerToken(localToken);
                    }
                    // Revenir sur le workflow initial (home sécurisé par ex.)
                    this.router.navigateByUrl('/main');
                }
            },
            error: (err) => {
                console.error('MSAL redirect error', err);
                this.alertService.error(
                    'Connexion via Microsoft Azure',
                    err?.message || 'Une erreur est survenue',
                );
                // UX: redirige vers la page de login avec un message si besoin
                this.router.navigateByUrl('/');
            },
        });
    }
}
